<template>
  <v-dialog v-model="showDialog" width="450" persistent>
    <v-card>
      <v-form ref="form" validate-on="invalid-input lazy" @submit.prevent="save">
        <v-card-title>{{ t("categories.editInitialAmountTitle") }}</v-card-title>
        <v-card-text>
          <div class="text-sm text-medium-emphasis mb-4">
            {{ t("categories.editInitialAmountHelp") }}
          </div>
          <v-text-field
            v-model.number="initialAmount"
            :rules="[nonnegativeNumber]"
            type="number"
            min="0"
            step="0.01"
            variant="outlined"
            autofocus
            :disabled="saving"
          >
            <template #label>{{ t("categories.initialAmount") }}</template>
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="saving" @click="showDialog = false">{{ t("common.cancel") }}</v-btn>
          <v-btn variant="flat" type="submit" color="primary" :loading="saving" :disabled="saving">
            {{ t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import { useI18n } from "@/composables/useI18n";
import { useRules } from "@/composables/useRules";
import { ref, watch } from "vue";
import type { VForm } from "vuetify/components";

const props = defineProps<{
  category: { id: string; initialAmount?: number } | null;
  saving?: boolean;
}>();
const emit = defineEmits<{ save: [value: number | null] }>();

const showDialog = defineModel<boolean>({ required: true });

const { t } = useI18n();
const { nonnegativeNumber } = useRules();
const form = ref<VForm>();

const initialAmount = ref<number | null>(null);

watch(
  () => [showDialog.value, props.category] as const,
  ([open, cat]) => {
    if (open) {
      initialAmount.value = cat?.initialAmount ?? null;
    }
  },
);

const save = async () => {
  const valid = await form.value?.validate();
  if (!valid?.valid) return;
  const value = initialAmount.value;
  emit("save", typeof value === "number" && Number.isFinite(value) ? value : null);
};
</script>
